import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconThreeBarsComponent } from "./med-icon-three-bars.component";

@NgModule({
  declarations: [
    MedIconThreeBarsComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconThreeBarsComponent,
  ],
})
export class MedIconThreeBarsModule { }
